import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useParams } from 'react-router-dom';

import DefaultHeader from '../Headers/defautHeader';
import ScreenLoader from '../UI/Loaders/screenLoader';
import DefaultFooter from '../Footers/defaultFooter';

import styles from './defaultLayout.module.css';

function DefaultLayout() {
    const [showLoader, setShowLoader] = useState(true);
    const tDirection = useSelector((state) => state.translation.textDirection);
    const loading = useSelector((state) => state.user.loading);
    const disableHeader = useSelector((state) => state.user.disableHeader);
    const location = useLocation();
    const { slug, id } = useParams();

    useEffect(() => {
        setTimeout(() => {
            setShowLoader(false);
        }, 1000);
    });
    const route = (
        location.pathname === '/employer-portal/create-job' ||
        location.pathname === '/employer-portal/applicants' ||
        location.pathname === '/employer-portal/candidates' ||
        location.pathname === '/employer-portal/jobs' ||
        location.pathname === `/employer-portal/${id}/edit` ||
        location.pathname === `/employer-portal/${id}` ||
        location.pathname === "/employer-portal" ||
        location.pathname.startsWith('/invoice/') && id ||
        location.pathname === '/create-account' ||
        location.pathname.includes('/profile') ||
        location.pathname === '/login' ||
        location.pathname === '/reset-password' ||
        location.pathname === '/welcome' ||
        location.pathname === '/profile' ||
        location.pathname === '/profile/billing-history' ||
        location.pathname === '/profile/billing' ||
        location.pathname === '/subscriptions' ||
        location.pathname === '/subscription-downgrade' ||
        location.pathname === "/profile/insights"
    )
    return (
        <>
            {loading || showLoader ? <ScreenLoader /> : null}
            {!loading &&
                <section className={location.pathname === "/profile/insights" ? '' : `${styles.default_layout} fcv-${tDirection}`}>
                    {disableHeader !== true && <DefaultHeader />}
                    <div className={location.pathname === "/profile/insights" ? '' : styles.content + 'fcv-content'}>
                        <div
                            className={
                                location.pathname.startsWith('/employers/') && slug
                                    ? styles.row :
                                    location.pathname.startsWith('/jobseekers/') && slug
                                        ? styles.row
                                        : route
                                            ? styles.row
                                            : styles.row + ' fcv-row'
                            }
                        >
                            <main>
                                <Outlet />
                            </main>
                        </div>
                        {location.pathname.startsWith('/jobseekers/') && slug ? <></> :
                            <>
                                <i></i>
                                <i></i>
                                <i></i>
                            </>
                        }
                    </div>
                    <DefaultFooter />
                </section >
            }
        </>
    );
}

export default DefaultLayout;